module.exports = __webpack_public_path__ + "img/SaveEnergies_80X30.7de28081.png";